module.exports = new __parcel__URL__("slideUpStartIcon.c77e14bd.svg").toString();